export const theme = {
  colors: {
    primary: {
      main: '#8BA96E',
      light: '#AFCF88',
      gradient: 'linear-gradient(to bottom, #AFCF88, #8BA96E)',
    },
    secondary: {
      main: '#4F728F',
      light: '#6A89A6',
      gradient: 'linear-gradient(to bottom, #6A89A6, #4F728F)',
    },
    success: {
      main: '#4A844F',
      light: '#5DA860',
      gradient: 'linear-gradient(to bottom, #5DA860, #4A844F)',
    },
    danger: {
      main: '#B2403F',
      light: '#D9534F',
      gradient: 'linear-gradient(to bottom, #D9534F, #B2403F)',
    },
    text: {
      primary: '#5A6B7B',
      secondary: '#4F728F',
      white: '#FFFFFF',
    },
    background: {
      default: '#f4f4f4',
      paper: '#FFFFFF',
    },
    border: '#CCCCCC',
  },
  typography: {
    fontFamily: "'Arial', sans-serif",
    h1: {
      fontSize: '24px',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '20px',
      color: '#5A6B7B',
    },
    body: {
      fontSize: '16px',
    },
  },
  spacing: {
    xs: '5px',
    sm: '10px',
    md: '20px',
    lg: '30px',
  },
  borderRadius: {
    sm: '5px',
    md: '6px',
    lg: '12px',
  },
  shadows: {
    button: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
}; 